import FirstSession from 'components/QuemSomosComponents/FirstSession'
import SecondSession from 'components/QuemSomosComponents/SecondSession'
import ThirdSession from 'components/QuemSomosComponents/ThirdSession'
import SEO from 'components/SEO'
import * as Style from './style'

function QuemSomos() {
  return (
    <Style.Container>
      <SEO
        title="Sobre Nós"
        description="Conheça a Cannect, empresa líder em cannabis medicinal no Brasil. Nossa missão é democratizar o acesso ao tratamento com cannabis medicinal de forma segura e legal."
        canonical="/sobre-nos"
        keywords="cannect, sobre nós, cannabis medicinal brasil, empresa cannabis, quem somos"
      />
      <FirstSession />
      <SecondSession />
      <ThirdSession />
    </Style.Container>
  )
}

export default QuemSomos
